import type { TeamMember } from './recipients/useTeamRecipients';
import {
  sendFailureOutcome,
  sendOutcome,
  type SendCopy,
  type SendOutcome,
  type SendRecipient
} from './sendOutcome';
import type { useShareWithTeamMutation } from './services/shareApi';

type ShareWithTeam = ReturnType<typeof useShareWithTeamMutation>[0];

interface TeamEmailSend {
  shareWithTeam: ShareWithTeam;
  photosetId: string;
  picked: readonly TeamMember[];
  note: string;
  copy: SendCopy;
}

/** The members picked, as a send names them: by user id, labelled by name. */
export const toSendRecipients = (
  picked: readonly TeamMember[]
): SendRecipient[] =>
  picked.map((member) => ({ id: member.userId, label: member.name }));

/**
 * One team email send and what it came to, shared by Internal Share
 * (DV-3715) and Make Visible & Notify (DV-3563). Resolves, never rejects:
 * a failed send is an outcome too.
 */
export const sendTeamEmail = async ({
  shareWithTeam,
  photosetId,
  picked,
  note,
  copy
}: TeamEmailSend): Promise<SendOutcome> => {
  const recipients = toSendRecipients(picked);
  try {
    const result = await shareWithTeam({
      photosetId,
      recipients: recipients.map((recipient) => recipient.id),
      note: note.trim() === '' ? undefined : note
    }).unwrap();
    return sendOutcome(recipients, result, copy);
  } catch (error: unknown) {
    return sendFailureOutcome(recipients, error, copy);
  }
};
